import React, { useState, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import ProcessingItem from './dashboard/ProcessingItem';

import "./WithScrollbar.scss";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const WithScrollbar = props => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (props.items) {
      setItems(props.items);
    }
  }, [props.items]);

  const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? 'transparent' : 'transparent',
    display: 'flex',
    overflow: 'auto',
  });

  const onDragEnd = result => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const newItems = reorder(
      items,
      result.source.index,
      result.destination.index
    );

    // console.log(newItems);
    setItems(newItems);
    props.itemsChange(newItems);
  }

  const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    // change background colour if dragging
    background: isDragging ? 'transparent' : 'transparent',
    display: 'flex',
    alignItems: 'center',
  
    // styles we need to apply on draggables
    ...draggableStyle,
  });

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable" direction="horizontal">
        {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver)}
              {...provided.droppableProps}
            >
              {
                items.map((item, index) => (
                  <Draggable key={item.id} draggableId={item.id} index={index}>
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style
                        )}
                      >
                        <ProcessingItem item={item} key={`collection_item_${index}`} onRemove={props.onRemoveItem} />
                      </div>
                    )}
                  </Draggable>
                ))
              }
              {
                props.uploadingItems.map((item, index) => (
                  <Draggable key={item.id} draggableId={item.id} index={items.length + index}>
                    {(provided, snapshot) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={getItemStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style
                        )}
                      >
                        <ProcessingItem item={item} isLoading={true} />
                      </div>
                    )}
                  </Draggable>
                ))
              }
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
  );
}

export default WithScrollbar;
